import { toast } from "react-toastify";
import firebase from "../../config/firebase";
import { RepositoryFactory } from "repositroy/RepositoryFactory";

export const getFansData =
  (filter, lastDocument, onComplete = () => {}) =>
  async (dispatch) => {
    try {
      let querya = firebase
        .firestore()
        .collection("users")
        .where("role", "==", "fan");
      if (filter.eduction) {
        querya = querya.where("education", "==", filter.eduction);
      }
      if (filter.state) {
        querya = querya.where("state", "==", filter.state);
      }
      if (filter.gender) {
        querya = querya.where("gender", "==", filter.gender);
      }
      if (filter.earnings) {
        querya = querya.where("income", "==", filter.earnings);
      }
      if (filter.familyState) {
        querya = querya.where("familyStatus", "==", filter.familyState);
      }
      if (filter.age) {
        const currentDate = new Date();
        const cutoffYear = currentDate.getFullYear() - Number(filter.age);
        const cutoffDate = new Date(cutoffYear, 11, 31, 23, 59, 59);

        const cutoffTimestamp =
          firebase.firestore.Timestamp.fromDate(cutoffDate);
        querya = querya
          .where("dateOfBirth", "<=", cutoffTimestamp)
          .orderBy("dateOfBirth", "desc");
      } else {
        querya = querya.orderBy("created_at", "desc");
      }

      if (lastDocument) {
        querya = querya.startAfter(lastDocument);
      }
      querya
        .limit(5)
        .get()
        .then(async (query) => {
          let temp_data = [];
          for await (let doc of query.docs) {
            temp_data.push({ ...doc.data(), id: doc.id });
          }

          dispatch({
            type: lastDocument ? "GET_FANS_DATA_MORE" : "GET_FANS_DATA",
            payload: {
              data: temp_data,
              lastDocument: query.docs[temp_data.length - 1] || null,
              hasMoreDocument: temp_data.length >= 5,
            },
          });

          onComplete();
        });
    } catch (error) {
      console.error("Error fetching fan data:", error);
      onComplete();
    }
  };
export const getFanSurvey =
  (onComplete = () => {}) =>
  async (dispatch) => {
    let surveyDoc = await firebase
      .firestore()
      .collection("stats")
      .doc("survey_stats");
    surveyDoc
      .get()
      .then((doc) => {
        if (doc.exists) {
          let survey_data = { ...doc.data(), id: doc.id };
          dispatch({
            type: "GET_FANS_SURVEY",
            payload: {
              survey_data,
            },
          });
        } else {
          console.error("No such document!");
        }
        onComplete();
      })
      .catch((error) => {
        console.error("Error fetching survey stats:", error);
        onComplete();
      });
  };

export const blockUser = (blocked, id, onComplete = () => {}) => {
  return async (dispatch) => {
    firebase
      .firestore()
      .collection("users")
      .doc(id)
      .update({ blocked: blocked })
      .then((res) => {
        if (blocked == true) {
          toast.warning("Fan account blocked successfully");
        } else {
          toast.success("Fan account unblocked successfully");
        }
        dispatch({
          type: "IS_FAN_BLOCK",
          payload: { id: id, block: blocked },
        });
        onComplete();
      });
  };
};

export const getStates = () => (dispatch) => {
  firebase
    .firestore()
    .collection("states")
    .orderBy("name", "asc")
    .onSnapshot((query) => {
      var tempStates = [];
      query.forEach((doc) => {
        tempStates.push({ id: doc.id, ...doc.data() });
      });
      dispatch({
        type: "GET_STATES",
        payload: tempStates,
      });
    });
};

export const getFanStatsFromApi =
  (onComplete = () => {}) =>
  (dispatch) => {
    const fanStats = RepositoryFactory.get("fanStats");
    fanStats
      .getFanStats()
      .then((response) => {
        const input = response.data;

        dispatch({
          type: "GET_STATS_FAN",
          payload: input.data,
        });
        onComplete();
      })
      .catch((error) => {
        console.error(error);
        onComplete();
      });
  };
